import React from "react";
import { Add, Delete } from "@mui/icons-material";
import {
  Box,
  Button,
  IconButton,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";

export const emptyConfigParam = () => ({ param: "", val: "" });

// Key and Value are both mandatory and each Key can only be used once,
// otherwise the params silently overwrite each other once serialised.
export const validateConfigParams = (formFields = []) => {
  const errors = formFields.map(() => ({}));
  const usedKeys = [];

  formFields.forEach((field, index) => {
    const param = (field.param || "").trim();
    const val = (field.val || "").trim();

    if (!param) {
      errors[index].param = "This field is required";
    } else if (usedKeys.includes(param)) {
      errors[index].param = "This key is already used";
    } else {
      usedKeys.push(param);
    }

    if (!val) {
      errors[index].val = "This field is required";
    }
  });

  return { errors, hasError: errors.some((e) => e.param || e.val) };
};

const ConfigurationParams = ({
  formFields,
  errors = [],
  onChange,
  onAdd,
  onRemove,
  disabled = false,
}) => {
  return (
    <Box>
      <Typography variant="h6" sx={{ my: 3 }}>
        Configuration Params
      </Typography>
      <Stack spacing={1}>
        {(formFields || []).map((form, index) => (
          <Stack
            key={index}
            direction="row"
            spacing={1}
            alignItems="flex-start"
          >
            <TextField
              name="param"
              label="Key"
              onChange={(event) => onChange(event, index)}
              value={form.param}
              required
              fullWidth
              size="small"
              error={Boolean(errors[index]?.param)}
              helperText={errors[index]?.param}
              disabled={disabled}
            />
            <TextField
              name="val"
              label="Value"
              onChange={(event) => onChange(event, index)}
              value={form.val}
              required
              fullWidth
              size="small"
              error={Boolean(errors[index]?.val)}
              helperText={errors[index]?.val}
              disabled={disabled}
            />
            <Tooltip title="Remove" placement="top">
              <span>
                <IconButton
                  aria-label="Remove"
                  onClick={() => onRemove(index)}
                  disabled={disabled}
                  sx={{ mt: 0.5 }}
                >
                  <Delete />
                </IconButton>
              </span>
            </Tooltip>
          </Stack>
        ))}
      </Stack>
      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
        <Button
          variant="outlined"
          startIcon={<Add />}
          onClick={onAdd}
          disabled={disabled}
        >
          Add More
        </Button>
      </Box>
    </Box>
  );
};

export default ConfigurationParams;
